import React, { useState } from 'react';

import styles from './overflowMenu.less';
import 'vxpattern-lib-paypal/dist/components/overflow-menu/overflow-menu.js';

const i18n = content('setPreferred/setPreferred');

import content from '../../lib/i18n';
import { trackLink, trackLinkWithData } from '../../lib/analytics';
import {
  SET_PREFERRED_PAGE_GROUP,
  SET_PREFERRED_PAGE_LANDING,
} from '../../lib/fptiTrackingVariables';

const OverflowMenu = React.memo(({ children, hubFlow, fptiInfo }) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const buttonStyle = hubFlow
    ? styles.hubOverflowMenuBtn
    : styles.setFavOverflowMenuBtn;
  const overFlowMenuStyle = hubFlow
    ? styles.hubOverFlowMenu
    : styles.setFavOverflowMenu;

  return (
    <>
      <button
        className={`vx_overflowMenu-btn ${buttonStyle}`}
        aria-label='Menu'
        aria-describedby='vx_overflowMenu-descriptor'
        onClick={(e) => {
          e.stopPropagation();
          setMenuIsOpen(!menuIsOpen);
          trackLink(
            'more',
            hubFlow ? fptiInfo.pgrp : SET_PREFERRED_PAGE_GROUP,
            hubFlow ? fptiInfo.page : SET_PREFERRED_PAGE_LANDING,
            'link'
          );
        }}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
        data-nemo='overflow-menu'
      >
        <span className='vx_icon vx_icon-medium vx_icon-slider-small' />
      </button>
      <div className={`vx_overflowMenu ${overFlowMenuStyle}`}>
        <ul className='vx_overflowMenu-list'>{children}</ul>
        <span id='vx_overflowMenu-descriptor' className='vx_a11yText'>
          {i18n('page1.page1.menuAllyText1')}
        </span>
        <span id='vx_overflowMenu-itemDescriptor' className='vx_a11yText'>
          {i18n('page1.page1.menuAllyText2')}
        </span>
      </div>
    </>
  );
});

export default OverflowMenu;
